import React from 'react';
import { Route, Switch, Redirect  } from 'react-router-dom';

import Layout from './hoc/Layout/Layout';
import Webgis from './containers/Webgis/Webgis';
import Login from './containers/LoginRegister/LoginRegister';
import Admin from './containers/Admin/Admin';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';

function App() {
  return (   
      <Layout>
          <Switch>
            <PrivateRoute path="/admin" component={Admin} />
            <Route path="/login" component={Login} />
            <Route path="/" exact component={Webgis} />
            <Redirect from="*" to="/" />
          </Switch>
      </Layout>
  );
}

export default App;